import { useState } from 'react';

const SocialMediaPortfolio = () => {
  const [activeProject, setActiveProject] = useState(0);

  const projects = [
    {
      title: "Parfüm TikTok Kanal",
      description: "Erfolgreiche TikTok-Strategie für Parfüm-Brand mit viralem Content und gezieltem Influencer-Marketing",
      image: "https://public.readdy.ai/ai/img_res/e0683c44-8c5c-4e53-a71c-715a3447431f.jpg",
      metrics: [
        "188K Views",
        "1.5K Profilaufrufe",
        "12.5% Engagement"
      ],
      tags: ["TikTok", "Parfüm", "Viral Content"]
    }
  ];

  return (
    <section id="portfolio" className="py-24 bg-black">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-3 text-[#d1bc8a] mb-6">
            <div className="w-2 h-2 bg-[#d1bc8a] rounded-full animate-pulse"></div>
            <span className="text-sm uppercase tracking-wider">Portfolio</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Unsere
            <span className="block text-[#d1bc8a]">Erfolgsgeschichten</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Entdecken Sie, wie wir Unternehmen dabei geholfen haben, ihre Social Media Präsenz zu transformieren und messbare Ergebnisse zu erzielen.
          </p>
        </div>

        {/* Portfolio wird nur angezeigt wenn Projekte vorhanden sind */}
        {projects.length > 0 ? (
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Project Navigation */}
            <div className="space-y-6">
              {projects.map((project, index) => (
                <div
                  key={index}
                  onClick={() => setActiveProject(index)}
                  className={`p-6 rounded-2xl cursor-pointer transition-all duration-300 hover:scale-105 ${
                    activeProject === index
                      ? 'bg-zinc-900 border-2 border-[#d1bc8a]'
                      : 'bg-zinc-900 border-2 border-zinc-800 hover:border-[#d1bc8a]/50'
                  }`}
                >
                  <h3 className="text-xl font-bold text-white mb-3">{project.title}</h3>
                  <p className="text-gray-400 mb-6 leading-relaxed">{project.description}</p>
                  
                  {/* Metrics */}
                  <div className="grid grid-cols-3 gap-4">
                    {project.metrics.map((metric, metricIndex) => (
                      <div key={metricIndex} className="text-center">
                        <div className="text-[#d1bc8a] font-bold text-lg">{metric}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Project Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={projects[activeProject]?.image}
                  alt={projects[activeProject]?.title}
                  className="w-full h-96 object-cover object-top grayscale hover:grayscale-0 transition-all duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>
              
              {/* Floating Elements */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#d1bc8a] rounded-full flex items-center justify-center shadow-xl">
                <i className="ri-trophy-line text-2xl text-black"></i>
              </div>
              <div className="absolute -bottom-6 -left-6 w-20 h-20 bg-zinc-800 rounded-full flex items-center justify-center shadow-xl border border-[#d1bc8a]">
                <i className="ri-rocket-line text-xl text-[#d1bc8a]"></i>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-24 h-24 bg-[#d1bc8a]/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-folder-open-line text-3xl text-[#d1bc8a]"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Portfolio wird aktualisiert</h3>
            <p className="text-gray-400 max-w-md mx-auto">
              Wir arbeiten daran, Ihnen unsere neuesten Projekte und Erfolgsgeschichten zu präsentieren.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default SocialMediaPortfolio;